import axios from "axios";
import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";

const SizeModal = ({ show, onClose, onAddSize, existingSizes = [] }) => {
  const [newSize, setNewSize] = useState({ width: "", length: "", height: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const parts = [newSize.height, newSize.length, newSize.width].filter(Boolean);
    if (parts.length === 0) {
      toast.error("Please enter at least one dimension.");
      return;
    }

    const formattedSize = parts.join(" x ");

    // 🔹 Check if size already exists
    const exists = existingSizes.some(
      (size) => size.value.toLowerCase() === formattedSize.toLowerCase()
    );
    if (exists) {
      toast.error("This size already exists.");
      return;
    }

    const payload = { size: formattedSize };

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_URL}/size`, payload);

      onAddSize({ value: formattedSize, label: formattedSize });

      setNewSize({ width: "", length: "", height: "" });
      onClose();
      toast.success("Size added successfully!");
    } catch (error) {
      console.error("Error adding size:", error);
      toast.error("Failed to add size. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Custom Size</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {["width", "length", "height"].map((field) => (
            <Form.Group key={field} className="mb-3">
              <Form.Label style={{ color: "black" }}>
                {field.charAt(0).toUpperCase() + field.slice(1)}
              </Form.Label>
              <Form.Control
                type="number"
                value={newSize[field]}
                onChange={(e) =>
                  setNewSize({ ...newSize, [field]: e.target.value })
                }
                placeholder={`Enter ${field}`}
              />
            </Form.Group>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add Size"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};


export default SizeModal;
